import * as React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { Button, Card, CardContent, CardMedia, InputAdornment, List, ListItem, ListItemIcon, TextField, Typography } from '@mui/material';

import './mainBanner.css';

import ResponsiveSlider from './Slider';
import Faq from './FAQ';

import Contact_IMG from '../../../assets/Logo/kl.webp';
import Our_Mission from '../../../assets/Landing/Rectangle-109.webp';
import Our_Visson from '../../../assets/Landing/Rectangle-110.webp';
import Praveen from '../../../assets/Landing/pr.webp';

import { AccountCircle, Email, Send } from '@mui/icons-material';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

export default function RowAndColumnSpacing() {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: '100vh' }}
    >
      <Box sx={{ width: '100%', position: 'relative', marginTop: '72px' }}>
        <Grid item xs={12} sm={12}>
          <Grid 
            container 
            direction={{ xs: 'column-reverse', md: 'row' }} // Reverse on small screens
          >
            <Grid item xs={12} md={6}>
              <CardContent sx={{ textAlign: { xs: 'center', md: 'left' } }}> {/* Center text on small screens */}
                <Typography 
                  variant="h3" 
                  component="div" 
                  gutterBottom  
                  color="#0067ff"
                  fontWeight={700}
                  sx={{ textAlign: { xs: 'center', md: 'left' } }} // Center "Contact Us" on small screens
                >
                  Why Us
                </Typography>
                <br />
                <br/>
                <Typography variant="subtitle1" color="#252525">
                  At KALEIDO International, we are more than just a service provider—we are your strategic partner in growth. Our team brings years of expertise across diverse industries, offering tailored solutions in accounting, technology, consulting, and more. We pride ourselves on innovation, agility, and a deep understanding of global market trends. With a client-centric approach, we don’t just meet your business needs; we exceed them by transforming challenges into opportunities for success.
                </Typography>
              </CardContent>
            </Grid>
            
            <Grid 
              item 
              xs={12} 
              md={6}
              sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center' 
              }}
            >
              <CardMedia
                component="img"
                image={Contact_IMG} // Replace with your image
                alt="Legal Services"
                style={{ height: '430px', width: '66%' }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {/* 2nd with responsive */}
      <Box 
  sx={{ 
    width: '100%', 
    position: 'relative', 
    marginTop: '72px',
    display: { xs: 'none', md: 'block' } // Visible only on small screens (<500px)
  }}
>
  <Grid item xs={12} sm={12}>
    <Grid 
      container 
      direction={{ xs: 'column-reverse', md: 'row' }} // Reverse on small screens
    >
      <Grid 
        item 
        xs={12} 
        md={6}
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}
      >
        <CardMedia
          component="img"
          image={Our_Mission} // Replace with your image
          alt="Legal Services"
          style={{ height: '290px', width: '66%', borderRadius: '8%' }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CardContent sx={{ textAlign: { xs: 'center', md: 'left' } }}> {/* Center text on small screens */} 
          <Typography 
            variant="h3" 
            component="div" 
            gutterBottom  
            color="#0067ff"
            fontWeight={700}
            sx={{ textAlign: { xs: 'center', md: 'left' } }} // Center "Contact Us" on small screens
          >
            Our Mission​
          </Typography>
          <br />
          <br />
          <Typography variant="subtitle1" color="#252525">
            Our mission is to provide tailored, high-quality business solutions that help our clients achieve their strategic objectives. By leveraging cutting-edge technology, expert financial management, and comprehensive consulting services, we create long-lasting partnerships that drive sustainable growth and success for businesses across the globe.
          </Typography>
        </CardContent>
      </Grid>
    </Grid>
  </Grid>
</Box>

<Box 
  sx={{ 
    width: '100%', 
    position: 'relative', 
    marginTop: '72px',
    display: { xs: 'block', md: 'none' } // Visible only on large screens (>500px)
  }}
>
  <Grid item xs={12} sm={12}>
    <Grid 
      container 
      direction={{ xs: 'column-reverse', md: 'row' }} // Reverse on small screens
    >
      <Grid item xs={12} md={6}>
        <CardContent sx={{ textAlign: { xs: 'center', md: 'left' } }}> {/* Center text on small screens */}
          <Typography 
            variant="h3" 
            component="div" 
            gutterBottom  
            color="#0067ff"
            fontWeight={700}
            sx={{ textAlign: { xs: 'center', md: 'left' } }} // Center "Contact Us" on small screens
          >
            Our Mission​
          </Typography>
          <br />
          <br />
          <Typography variant="subtitle1" color="#252525">
            Our mission is to provide tailored, high-quality business solutions that help our clients achieve their strategic objectives. By leveraging cutting-edge technology, expert financial management, and comprehensive consulting services, we create long-lasting partnerships that drive sustainable growth and success for businesses across the globe.
          </Typography>
        </CardContent>
      </Grid>
      <Grid 
        item 
        xs={12} 
        md={6}
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}
      >
        <CardMedia
          component="img"
          image={Our_Mission} // Replace with your image
          alt="Legal Services"
          style={{ height: '290px', width: '66%', borderRadius: '8%' }}
        />
      </Grid>
    </Grid>
  </Grid>
</Box>

        {/* 3rd Banner with responsive */}
      <Box 
  sx={{ 
    width: '100%', 
    position: 'relative', 
    marginTop: '72px',
    display: { xs: 'block', md: 'none' } // Visible only on small screens (<500px)
  }}
>
  <Grid item xs={12} sm={12}>
    <Grid 
      container 
      direction={{ xs: 'column-reverse', md: 'row' }} // Reverse on small screens
    >
      <Grid 
        item 
        xs={12} 
        md={6}
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}
      >
        <CardMedia
          component="img"
          image={Our_Visson} // Replace with your image
          alt="Legal Services"
          style={{ height: '290px', width: '66%', borderRadius: '8%' }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CardContent sx={{ textAlign: { xs: 'center', md: 'left' } }}> {/* Center text on small screens */} 
          <Typography 
            variant="h3" 
            component="div" 
            gutterBottom  
            color="#0067ff"
            fontWeight={700}
            sx={{ textAlign: { xs: 'center', md: 'left' } }} // Center "Contact Us" on small screens
          >
            Our Vision
          </Typography>
          <br />
          <br />
          <Typography variant="subtitle1" color="#252525">
          To be a global leader in delivering innovative and comprehensive business solutions that empower organizations to thrive in a constantly evolving marketplace. We aim to set the standard for excellence by fostering growth, driving innovation, and enhancing value for businesses worldwide.
          </Typography>
        </CardContent>
      </Grid>
    </Grid>
  </Grid>
</Box>

<Box 
  sx={{ 
    width: '100%', 
    position: 'relative', 
    marginTop: '72px',
    display: { xs: 'none', md: 'block' } // Visible only on large screens (>500px)
  }}
>
  <Grid item xs={12} sm={12}>
    <Grid 
      container 
      direction={{ xs: 'column-reverse', md: 'row' }} // Reverse on small screens
    >
      <Grid item xs={12} md={6}>
        <CardContent sx={{ textAlign: { xs: 'center', md: 'left' } }}> {/* Center text on small screens */}
          <Typography 
            variant="h3" 
            component="div" 
            gutterBottom  
            color="#0067ff"
            fontWeight={700}
            sx={{ textAlign: { xs: 'center', md: 'left' } }} // Center "Contact Us" on small screens
          >
            Our Vision
          </Typography>
          <br />
          <br />
          <Typography variant="subtitle1" color="#252525">
          To be a global leader in delivering innovative and comprehensive business solutions that empower organizations to thrive in a constantly evolving marketplace. We aim to set the standard for excellence by fostering growth, driving innovation, and enhancing value for businesses worldwide.
          </Typography>
        </CardContent>
      </Grid>
      <Grid 
        item 
        xs={12} 
        md={6}
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}
      >
        <CardMedia
          component="img"
          image={Our_Visson} // Replace with your image
          alt="Legal Services"
          style={{ height: '290px', width: '66%', borderRadius: '8%' }}
        />
      </Grid>
    </Grid>
  </Grid>
</Box>

<Grid container sm={11}>

<Box sx={{ width: '100%', mt: 4, display: { xs: 'none', md: 'block' } }}>
        <ResponsiveSlider />
      </Box>
</Grid>

{/* 4th Banner with responsive */}
<Box 
  sx={{ 
    width: '100%', 
    position: 'relative', 
    marginTop: '72px',
    display: { xs: 'none', md: 'block' } // Visible only on small screens (<500px)
  }}
>
  <Grid item xs={12} sm={12}>
    <Grid 
      container 
      direction={{ xs: 'column-reverse', md: 'row' }} // Reverse on small screens
    >
      <Grid 
        item 
        xs={12} 
        md={6}
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}
      >
        <CardMedia
          component="img"
          image={Praveen} // Replace with your image
          alt="Legal Services"
          style={{ height: '457px', width: '66%', borderRadius: '8%' }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
      <CardContent sx={{ textAlign: { xs: 'center', md: 'left' } }}> 
  {/* Center text on small screens */} 
  <Typography 
    variant="h3" 
    component="div" 
    gutterBottom  
    color="#0067ff"
    fontWeight={700}
    sx={{ textAlign: { xs: 'center', md: 'left' } }} // Center name on small screens
  >
    Puraveen Yogarasa
  </Typography>
  <Typography variant="h5" 
    component="div" 
    gutterBottom  
    color="#0067ff"
    fontWeight={700}
    sx={{ textAlign: { xs: 'center', md: 'left' } }}>
    Director and Co-founder
  </Typography>
  <br />
  <br />
  <Typography variant="subtitle1" color="#252525">
    Puraveen brings over nine years of expertise in the Technology Development and BPO sectors, specializing in areas like Fintech, Retail, Robotic Process Automation, and Data Analytics. His proficiency in financial management and decision-making, combined with tools like Power BI and QuickBooks, has been instrumental in managing organizations in markets such as Sri Lanka, Australia, and the UK. Puraveen's strategic financial insights empower KALEIDO to offer cutting-edge solutions for sustained business growth.
  </Typography>

  {/* Add list items below */}
  <List>
    <ListItem>
      <ListItemIcon>
        <Send sx={{ color: "#0067ff" }} /> {/* You can change the icon */}
      </ListItemIcon>
      <Typography variant="subtitle1" color="#252525">
      BSc Accounting
      </Typography>
    </ListItem>
    <ListItem>
      <ListItemIcon>
        <Send sx={{ color: "#0067ff" }} />
      </ListItemIcon>
      <Typography variant="subtitle1" color="#252525">
      CMA (Australia)
      </Typography>
    </ListItem>
    <ListItem>
      <ListItemIcon>
        <Send sx={{ color: "#0067ff" }} />
      </ListItemIcon>
      <Typography variant="subtitle1" color="#252525">
      IFA AIPA (UK)
      </Typography>
    </ListItem>
  </List>
</CardContent>

      </Grid>
    </Grid>
  </Grid>
</Box>

<Box 
  sx={{ 
    width: '100%', 
    position: 'relative', 
    marginTop: '72px',
    display: { xs: 'block', md: 'none' } // Visible only on large screens (>500px)
  }}
>
  <Grid item xs={12} sm={12}>
    <Grid 
      container 
      direction={{ xs: 'column-reverse', md: 'row' }} // Reverse on small screens
    >
      <Grid item xs={12} md={6}>
      <CardContent sx={{ textAlign: { xs: 'center', md: 'left' } }}> 
  {/* Center text on small screens */} 
  <Typography 
    variant="h3" 
    component="div" 
    gutterBottom  
    color="#0067ff"
    fontWeight={700}
    sx={{ textAlign: { xs: 'center', md: 'left' } }} // Center name on small screens
  >
    Puraveen Yogarasa
  </Typography>
  <Typography variant="h5" 
    component="div" 
    gutterBottom  
    color="#0067ff"
    fontWeight={700}
    sx={{ textAlign: { xs: 'center', md: 'left' } }}>
    Director and Co-founder
  </Typography>
  <br />
  <br />
  <Typography variant="subtitle1" color="#252525">
    Puraveen brings over nine years of expertise in the Technology Development and BPO sectors, specializing in areas like Fintech, Retail, Robotic Process Automation, and Data Analytics. His proficiency in financial management and decision-making, combined with tools like Power BI and QuickBooks, has been instrumental in managing organizations in markets such as Sri Lanka, Australia, and the UK. Puraveen's strategic financial insights empower KALEIDO to offer cutting-edge solutions for sustained business growth.
  </Typography>

  {/* Add list items below */}
  <List>
    <ListItem>
      <ListItemIcon>
        <Send sx={{ color: "#0067ff" }} /> {/* You can change the icon */}
      </ListItemIcon>
      <Typography variant="subtitle1" color="#252525">
      BSc Accounting
      </Typography>
    </ListItem>
    <ListItem>
      <ListItemIcon>
        <Send sx={{ color: "#0067ff" }} />
      </ListItemIcon>
      <Typography variant="subtitle1" color="#252525">
      CMA (Australia)
      </Typography>
    </ListItem>
    <ListItem>
      <ListItemIcon>
        <Send sx={{ color: "#0067ff" }} />
      </ListItemIcon>
      <Typography variant="subtitle1" color="#252525">
      IFA AIPA (UK)
      </Typography>
    </ListItem>
  </List>
</CardContent>
      </Grid>
      <Grid 
        item 
        xs={12} 
        md={6}
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}
      >
        <CardMedia
          component="img"
          image={Praveen} // Replace with your image
          alt="Legal Services"
          style={{ height: '457px', width: '66%', borderRadius: '8%' }}
        />
      </Grid>
    </Grid>
  </Grid>
</Box>

{/* 5th Banner with responsive */}
<Box 
  sx={{ 
    width: '100%', 
    position: 'relative', 
    marginTop: '72px',
    display: { xs: 'none', md: 'block' } // Visible only on small screens (<500px)
  }}
>
  <Grid item xs={12} sm={12}>
    <Grid 
      container 
      direction={{ xs: 'column-reverse', md: 'row' }} // Reverse on small screens
    >
      <Grid item xs={12} md={6}>
      <CardContent sx={{ textAlign: { xs: 'center', md: 'left' } }}> 
  {/* Center text on small screens */} 
  <Typography 
    variant="h3" 
    component="div" 
    gutterBottom  
    color="#0067ff"
    fontWeight={700}
    sx={{ textAlign: { xs: 'center', md: 'left' } }} // Center name on small screens
  >
    Lalidaran Ramasamy​
  </Typography>
  <Typography variant="h5" 
    component="div" 
    gutterBottom  
    color="#0067ff"
    fontWeight={700}
    sx={{ textAlign: { xs: 'center', md: 'left' } }}>
    Director
  </Typography>
  <br />
  <br />
  <Typography variant="subtitle1" color="#252525">
  With over a decade of experience, Lalidaran is a seasoned financial strategist. He has worked across industries such as IT, Travel, and Conglomerates, providing financial leadership in markets like Sri Lanka, Canada, and the UAE. His background with Big4 firms and global enterprises enables him to offer expert guidance in financial planning, process optimization, and growth strategies. Lalidaran's leadership ensures KALEIDO delivers top-tier financial and business consulting solutions globally.
  </Typography>

  {/* Add list items below */}
  <List>
    <ListItem>
      <ListItemIcon>
        <Send sx={{ color: "#0067ff" }} /> {/* You can change the icon */}
      </ListItemIcon>
      <Typography variant="subtitle1" color="#252525">
      MBA (UK)
      </Typography>
    </ListItem>
    <ListItem>
      <ListItemIcon>
        <Send sx={{ color: "#0067ff" }} />
      </ListItemIcon>
      <Typography variant="subtitle1" color="#252525">
      ACMA CGMA - CIMA (UK)
      </Typography>
    </ListItem>
  </List>
</CardContent>
      </Grid>
      <Grid 
        item 
        xs={12} 
        md={6}
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}
      >
        <CardMedia
          component="img"
          image={Praveen} // Replace with your image
          alt="Legal Services"
          style={{ height: '457px', width: '66%', borderRadius: '8%' }}
        />
      </Grid>
    </Grid>
  </Grid>
</Box>

<Box 
  sx={{ 
    width: '100%', 
    position: 'relative', 
    marginTop: '72px',
    display: { xs: 'block', md: 'none' } // Visible only on large screens (>500px)
  }}
>
  <Grid item xs={12} sm={12}>
    <Grid 
      container 
      direction={{ xs: 'column-reverse', md: 'row' }} // Reverse on small screens
    >
      <Grid item xs={12} md={6}>
      <CardContent sx={{ textAlign: { xs: 'center', md: 'left' } }}> 
  {/* Center text on small screens */} 
  <Typography 
    variant="h3" 
    component="div" 
    gutterBottom  
    color="#0067ff"
    fontWeight={700}
    sx={{ textAlign: { xs: 'center', md: 'left' } }} // Center name on small screens
  >
    Lalidaran Ramasamy​
  </Typography>
  <Typography variant="h5" 
    component="div" 
    gutterBottom  
    color="#0067ff"
    fontWeight={700}
    sx={{ textAlign: { xs: 'center', md: 'left' } }}>
    Director
  </Typography>
  <br />
  <br />
  <Typography variant="subtitle1" color="#252525">
  With over a decade of experience, Lalidaran is a seasoned financial strategist. He has worked across industries such as IT, Travel, and Conglomerates, providing financial leadership in markets like Sri Lanka, Canada, and the UAE. His background with Big4 firms and global enterprises enables him to offer expert guidance in financial planning, process optimization, and growth strategies. Lalidaran's leadership ensures KALEIDO delivers top-tier financial and business consulting solutions globally.
  </Typography>

  {/* Add list items below */}
  <List>
    <ListItem>
      <ListItemIcon>
        <Send sx={{ color: "#0067ff" }} /> {/* You can change the icon */}
      </ListItemIcon>
      <Typography variant="subtitle1" color="#252525">
      MBA (UK)
      </Typography>
    </ListItem>
    <ListItem>
      <ListItemIcon>
        <Send sx={{ color: "#0067ff" }} />
      </ListItemIcon>
      <Typography variant="subtitle1" color="#252525">
      ACMA CGMA - CIMA (UK)
      </Typography>
    </ListItem>
  </List>
</CardContent>
      </Grid>
      <Grid 
        item 
        xs={12} 
        md={6}
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}
      >
        <CardMedia
          component="img"
          image={Praveen} // Replace with your image
          alt="Legal Services"
          style={{ height: '457px', width: '66%', borderRadius: '8%' }}
        />
      </Grid>
    </Grid>
  </Grid>
</Box>

<Box
      sx={{
        width: '100%',
        marginTop: '72px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center', // Center the FAQ heading
        justifyContent: 'center',
        padding: '0 24px', // Add some padding for responsiveness
      }}
    >
      {/* FAQ Heading */}
      <Typography 
        variant="h3" 
        textAlign="center" 
        gutterBottom 
        sx={{
          fontWeight: '700',
          color: '#0067ff',
        }}
      >
        FAQ
      </Typography>

      {/* FAQ Component with accordions */}
      <Box sx={{ width: '100%', maxWidth: '900px' }}> {/* Set a max width to avoid content stretching on large screens */}
        <Faq />
      </Box>
    </Box>
    </Grid>
  );
}
